const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabsquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 31.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tabsquare Logo 2019") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "6.01 12.02 25.46 12.02 25.46 16.56 18.57 16.56 18.57 31.47 12.9 31.47 12.91 16.56 6.01 16.56 6.01 12.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.24,203.12v21.62a4.93,4.93,0,0,0,4.93,4.93h8V214.75h-6.9v-4.54h19.45v4.54h-6.89v14.91h8a4.93,4.93,0,0,0,4.93-4.93V203.12a4.93,4.93,0,0,0-4.93-4.93H529.17A4.93,4.93,0,0,0,524.24,203.12Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.71,
    y: 23.34,
    width: 2.7,
    height: 2.7,
    rx: 0.42,
    ry: 0.42,
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.13,207v17.2h-3V207h-5.48v-2.71h14V207h-5.48Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.41,224.24l-1.37-4h-7.86l-1.37,4h-3.22l7.3-19.92h2.43l7.3,19.92h-3.22Zm-5.23-15.41-3.11,8.84h6.13Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.11,224.24H614V204.32h7.75c3.69,0,6,2.1,6,5.45a4.51,4.51,0,0,1-2.69,4.22,4.74,4.74,0,0,1,3,4.62C628.12,222.28,625.63,224.24,622.11,224.24ZM621.55,207h-4.48v5.71h4.48c1.93,0,3.25-1,3.25-2.85S623.48,207,621.55,207Zm0.28,8.42h-4.76v6.07h4.76A3,3,0,1,0,621.83,215.45Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.48,224.4c-3,0-5.15-.7-7-2.63l2-2a6.57,6.57,0,0,0,5.09,1.9c2.6,0,4.11-1.12,4.11-3a2.68,2.68,0,0,0-.78-2.07,3.46,3.46,0,0,0-2.18-.84l-2.35-.34a6.82,6.82,0,0,1-3.78-1.59,5,5,0,0,1-1.45-3.8c0-3.47,2.52-5.85,6.66-5.85a8.29,8.29,0,0,1,6.18,2.27l-1.93,1.9a5.85,5.85,0,0,0-4.34-1.54c-2.35,0-3.64,1.34-3.64,3.1a2.37,2.37,0,0,0,.75,1.85,4.45,4.45,0,0,0,2.24.92L645.3,213a6.59,6.59,0,0,1,3.72,1.48,5.21,5.21,0,0,1,1.62,4.08C650.64,222.22,647.65,224.4,643.48,224.4Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.88,225.13l-2-2a7.2,7.2,0,0,1-4.17,1.26,7.13,7.13,0,0,1-5.23-2.13c-2-2-1.93-4.17-1.93-8s0-6,1.93-8a7.53,7.53,0,0,1,10.49,0c2,2,1.9,4.17,1.9,8,0,3.38,0,5.45-1.29,7.25l2,1.93Zm-3.19-17a4.19,4.19,0,0,0-5.93,0c-1,1.06-1.17,2.18-1.17,6.18s0.2,5.12,1.17,6.18a4.07,4.07,0,0,0,3,1.23,3.47,3.47,0,0,0,2-.64l-2.1-2.1,1.68-1.68,1.93,1.93c0.5-1,.59-2.35.59-4.92C670.87,210.28,670.67,209.16,669.69,208.09Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.79,224.4c-4.06,0-7.13-2.77-7.13-6.88v-13.2h3v13.06c0,2.66,1.62,4.31,4.11,4.31a4,4,0,0,0,4.14-4.31V204.32h3v13.2C697.95,221.63,694.84,224.4,690.79,224.4Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.88,224.24l-1.37-4h-7.86l-1.37,4h-3.22l7.3-19.92h2.43l7.3,19.92h-3.22Zm-5.23-15.41-3.11,8.84h6.13Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.51,224.24l-4.2-8.39h-3.78v8.39h-3V204.32h7.72c3.78,0,6.18,2.43,6.18,5.82a5.23,5.23,0,0,1-4,5.29l4.59,8.81h-3.52ZM739,207h-4.48v6.24H739c2,0,3.38-1.15,3.38-3.11A3.05,3.05,0,0,0,739,207Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.44,224.24V204.32h12.73V207h-9.71v5.82h8.28v2.69h-8.28v6h9.71v2.71H755.44Z",
    transform: "translate(-524.24 -198.19)",
    style: {
      fill: "#55565a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.18 19.49 260.01 19.49 257.58 26.13 260.8 26.13 262.33 21.7 269.91 21.7 271.4 26.13 274.62 26.13 272.18 19.49",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.63 15.06 261.64 15.06 260.83 17.28 263.87 17.28 264.63 15.06",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.41 17.28 271.37 17.28 270.56 15.06 267.66 15.06 268.41 17.28",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.17 10.64 263.26 10.64 262.45 12.85 265.4 12.85 266.17 10.64",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.92 12.85 269.75 12.85 268.94 10.64 266.17 10.64 266.92 12.85",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.13 8.42 267.32 6.21 264.88 6.21 264.07 8.42 268.13 8.42",
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.45,
    y: 19.49,
    width: 3.01,
    height: 6.64,
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.45,
    y: 15.06,
    width: 3.01,
    height: 2.21,
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.45,
    y: 10.75,
    width: 3.01,
    height: 2.21,
    style: {
      fill: "#ff6b00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.45,
    y: 6.21,
    width: 3.01,
    height: 2.21,
    style: {
      fill: "#ff6b00"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsquare);
export default __webpack_public_path__ + "static/media/tabsquare.2a15fe2d5d150aec04ec9b6c1e1a69b7.svg";
export { ForwardRef as ReactComponent };